import React, { useState } from "react";

import { ShareDialog } from "#app/components/sharing/share-dialog";
import { useAppData } from "#app/lib/data";
import { useWorkflowSharing } from "#app/lib/hooks/use-workflow-sharing";

// Workflow-specific wrapper around the generic ShareDialog. Owns the
// debounced search → useWorkflowSharing wiring and the workflow's
// display name / icon for the subheader.

type WorkflowShareDialogProps = {
  workflowId: string | null;
  onOpenChange: (open: boolean) => void;
};

export function WorkflowShareDialog({
  workflowId,
  onOpenChange,
}: WorkflowShareDialogProps) {
  const { workflows } = useAppData();
  const workflow = workflows.find((w) => w.workflowId === workflowId);
  const [activeSearch, setActiveSearch] = useState<string | undefined>(
    undefined,
  );

  const sharing = useWorkflowSharing(workflowId, activeSearch);

  return (
    <ShareDialog
      open={workflowId != null}
      onOpenChange={onOpenChange}
      title="Share this workflow"
      subheaderText="Sharing as a single workflow of"
      subheaderIcon={workflow?.icon}
      subheaderName={workflow?.name ?? "—"}
      onSearchChange={setActiveSearch}
      {...sharing}
    />
  );
}
